(function () {
  "use strict";

  angular.module("DestinationProfileProperties")
    .controller("DestinationProfilePropertiesController", ["$location",
        "$scope", "$filter", "toastr", 'EventHandlerService', 'currentTenant', 'DestinationProfileService',
        '$routeParams', 'URL_PARAMS', '$rootScope', 'EventServiceEvents',
        /**
         *
         * @param {DestinationProfileService} DestinationProfileService
         */
        function (
          $location, $scope, $filter, toastr, EventHandlerService, currentTenant, DestinationProfileService,
          $routeParams, URL_PARAMS, $rootScope, EventServiceEvents) {

          $scope.tenant = currentTenant;
          $scope.editableProfile = null;
          $scope.me = null;

          $scope.helpCaption = "HelpDestinationProfiles";

          (function(){
            initEventHandler();
            setListeners();
            checkoutDestinationProfile();
          })();

          $scope.$watch(function () {
            return $rootScope.currentUser
          }, function() {
            if ($rootScope.currentUser) {
              $scope.me = $rootScope.currentUser;
            }
          })

          function checkoutDestinationProfile () {
            const destinationProfileId = $routeParams[URL_PARAMS.DESTINATION_PROFILE_ID.ROUTE];

            DestinationProfileService.checkoutProfileById(destinationProfileId).then(function(editableProfile) {
              $scope.editableProfile = editableProfile;
            }).catch(function (error) {

              // If we could not obtain working copy of the profile, redirect to the destination profile
              // list and show the error in a toast message.
              $location.path('/settings/').search({ settingsSection: 'destinationProfiles' });
              toastr.error($filter('translate')(error.data.errorCode));
            });
          }

          function initEventHandler() {
            EventHandlerService.deRegisterListeners();
          };

          function updateDestinationProfile() {
            DestinationProfileService.getProfileById($routeParams[URL_PARAMS.DESTINATION_PROFILE_ID.ROUTE]).then(function(destinationProfileModel) {
              $rootScope.$broadcast(`DESTINATION_PROFILE_UPDATED_${$routeParams[URL_PARAMS.DESTINATION_PROFILE_ID.ROUTE]}`, {destinationProfile: destinationProfileModel});
            }).catch(function (error) {

            })
          }

          function setListeners () {
            $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.DESTINATION_PROFILE_UPDATED, function (name, data) {
              const destinationProfile = data.destinationProfile.split('/').pop();
              if (destinationProfile === $routeParams[URL_PARAMS.DESTINATION_PROFILE_ID.ROUTE]) {
                updateDestinationProfile();
              }
            });
          }

          $scope.$on('REQUEST_ERROR_HELP', (name, data) => {
            $scope.error = data.error;
          })

          $scope.clearError = () => {
            $scope.error = null;
          }

          /**
           * Handle closing the destination profile editor dialog.
           *
           * @param {DestinationProfileModel} newProfile The updated destination profile when the dialog was closed using the "Save" button or undefined when the dialog was closed using the "Close" button.
           */
          $scope.handleProfileDialogClosed = (newProfile) => {
            if (!newProfile) {
              DestinationProfileService.deleteProfiles([$scope.editableProfile]).then(function(response) {
              }).catch(function (error) {
              });
            }

            $location.path('/settings/').search({ settingsSection: 'destinationProfiles' });
          };
      }]);
})();
